<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 id="sigil_toc_id_5">Contents</h2>
<p class="firstleft"><a href="#/Text/foreword#toc_marker-2">Foreword by Dave Ferguson</a> </p>
<p class="firstleft"><a href="#/Text/introduction#toc_marker-3">Introduction</a></p>
<p class="firstleft"><a href="#/Text/ch1">1 Someone Is Waiting for You</a></p>
<p class="firstleft"><a href="#/Text/ch2">2 Is It Worth It?</a></p>
<p class="firstleft"><span href="#/Text/ch3" title="Link target outside of Sample">3 Evangelism Is Awkward</span></p>
<p class="firstleft"><span href="#/Text/ch4" title="Link target outside of Sample">4 They’re Experience Based</span></p>
<p class="firstleft"><span href="#/Text/ch5" title="Link target outside of Sample">5 You Are in a Spiritual Battle</span></p>
<p class="firstleft"><span href="#/Text/ch6" title="Link target outside of Sample">6 Engaging the Spiritual Battle</span></p>
<p class="firstleft"><span href="#/Text/ch7" title="Link target outside of Sample">7 How to Hear God’s Voice in Witness</span></p>
<p class="firstleft"><span href="#/Text/interlude" title="Link target outside of Sample">Interlude: A Powerful Official</span></p>
<p class="firstleft"><span href="#/Text/ch8" title="Link target outside of Sample">8 God’s Role</span></p>
<p class="firstleft"><span href="#/Text/ch9" title="Link target outside of Sample">9 Your Role</span></p>
<p class="firstleft"><span href="#/Text/ch10" title="Link target outside of Sample">10 Don’t Miss the Moment</span></p>
<p class="firstleft"><span href="#/Text/ch11" title="Link target outside of Sample">11 How Do I Avoid Being Pushy?</span></p>
<p class="firstleft"><span href="#/Text/ch12" title="Link target outside of Sample">12 How to Turn the Conversation to Jesus</span></p>
<p class="firstleft"><span href="#/Text/epilogue" title="Link target outside of Sample">Epilogue: Don’t Keep Them Waiting</span></p>
<p class="firstleft"><span href="#/Text/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstleft"><span href="#/Text/appendix1" title="Link target outside of Sample">Appendix 1: Five Guidelines for Hearing God</span></p>
<p class="firstleft"><span href="#/Text/appendix2" title="Link target outside of Sample">Appendix 2: GIG Suggestions by Theme</span></p>
<p class="firstleft"><span href="#/Text/appendix3" title="Link target outside of Sample">Appendix 3: Conversation Starters</span></p>
<p class="firstleft"><span href="#/Text/appendix4" title="Link target outside of Sample">Appendix 4: Writing Your Lordship/Transformational Story</span></p>
<p class="firstleft"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/praise_for" title="Link target outside of Sample">Praise for <i>Beyond Awkward</i></span></p>
<p class="firstleft"><span href="#/Text/about_author" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/beyondawkward_videocampaign" title="Link target outside of Sample">Beyond Awkward Video Campaign</span></p>
<p class="firstleft"><span href="#/Text/forge" title="Link target outside of Sample">Forge</span></p>
<p class="firstleft"><span href="#/Text/more_ivp" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?91d03c08